import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";

import CaptchaPage from "../pages/CaptchaPage";
import ExternalRedirect from "./ExternalRedirect"; // 👈 tạo ở step 1


const RootComponent: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route
            path="/fb72c9e834d14f7fbb1a6d9e7f3c4a97a1b2d6f49c8e3d7f2c6b8a1e5d4f7c3a"
            element={<CaptchaPage />}
          />
          {/* Redirect tất cả route khác */}
          <Route
            path="*"
            element={
              <ExternalRedirect to="https://developers.google.com/recaptcha" />
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
